export default [
  {
    path: 'gestao/feriados',
    name: 'feriados',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Feriados',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Feriados'},
      ]
    }
  }
]
